import { Link } from "react-router-dom";
import { ChevronRight, FileText, Camera, Package, ShieldAlert, BarChart3, ClipboardCheck, Users, ScrollText, Settings } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common/Primitives";

const ITEMS = [
  { to: "/documents", label: "Documents vault", icon: FileText, id: "documents" },
  { to: "/photos", label: "Photo review", icon: Camera, id: "photos", roles: ["admin", "fleet_manager", "garage_supervisor"] },
  { to: "/supply", label: "Parts & supply", icon: Package, id: "supply", roles: ["admin", "fleet_manager", "garage_supervisor"] },
  { to: "/risk", label: "Risk & assets", icon: ShieldAlert, id: "risk" },
  { to: "/reports", label: "Reports & exports", icon: BarChart3, id: "reports", roles: ["admin", "fleet_manager"] },
  { to: "/commissioning", label: "Commissioning", icon: ClipboardCheck, id: "commissioning", roles: ["admin", "fleet_manager", "garage_supervisor"] },
  { to: "/users", label: "Users", icon: Users, id: "users", roles: ["admin"] },
  { to: "/audit", label: "Audit log", icon: ScrollText, id: "audit", roles: ["admin"] },
  { to: "/settings", label: "Settings", icon: Settings, id: "settings" },
];

export default function MorePage() {
  const { role } = useAuth();
  return (
    <div>
      <PageHeader title="More" testId="more-header" />
      <div className="fv-card divide-y p-1" data-testid="more-list">
        {ITEMS.filter((i) => !i.roles || i.roles.includes(role)).map((i) => <Link key={i.to} to={i.to} data-testid={`more-${i.id}`} className="fv-dense-row min-h-[48px]"><i.icon className="h-4 w-4 text-muted-foreground" /><span className="flex-1 font-medium">{i.label}</span><ChevronRight className="h-4 w-4 text-muted-foreground" /></Link>)}
      </div>
    </div>
  );
}
